// ---------------------------------------------------------------------------
// Attendance module — API endpoint constants
// ---------------------------------------------------------------------------
// NOTE: This file is intentionally kept INSIDE the Attendance module so that the
// attendance feature owns its own API surface and stays decoupled from the Bell
// code. It only borrows the shared BASE_URL / WS base from the global config.
// ---------------------------------------------------------------------------
import {BASE, BASE_URL} from "../../../../constants/ApiConstant";

const ATTENDANCE = "/attendance";
const CLASS = "/class";
const STUDENT = "/student";
const MARK = "/mark";
const SEARCH = "/search";
const SUMMARY = "/summary";
const DAILY = "/daily";
const LIVE = "/live";

export const attendanceApiConstants = {
    // Reference / lookups
    FETCH_CLASSES: BASE_URL.concat(ATTENDANCE).concat(CLASS),
    FETCH_STUDENTS: BASE_URL.concat(ATTENDANCE).concat(STUDENT).concat(SEARCH),

    // Daily attendance
    FETCH_DAILY: BASE_URL.concat(ATTENDANCE).concat(DAILY),
    MARK_ATTENDANCE: BASE_URL.concat(ATTENDANCE).concat(MARK),

    // Records / reporting (datatable)
    SEARCH_RECORDS: BASE_URL.concat(ATTENDANCE).concat(SEARCH),
    FETCH_SUMMARY: BASE_URL.concat(ATTENDANCE).concat(SUMMARY),

    // Real-time feed
    LIVE_FEED: BASE_URL.concat(ATTENDANCE).concat(LIVE),
};

// STOMP/SockJS destinations for the real-time attendance feed. Kept separate
// from the bell scheduler topic (/topic/scheduler) so the two never collide.
export const attendanceSocketConstants = {
    WS_ENDPOINT: BASE + "/ws",
    TOPIC_LIVE: "/topic/attendance",
};

// Canonical attendance status codes used across the whole module.
export const ATTENDANCE_STATUS = {
    PRESENT: "PRESENT",
    ABSENT: "ABSENT",
    LATE: "LATE",
    LEAVE: "LEAVE",
};
